export default {
  viewBox: "0 0 40 40",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20 3.75c.69 0 1.25.56 1.25 1.25v26.982l10.366-10.366a1.25 1.25 0 0 1 1.768 1.768l-12.5 12.5a1.25 1.25 0 0 1-1.768 0l-12.5-12.5a1.25 1.25 0 0 1 1.768-1.768L18.75 31.982V5c0-.69.56-1.25 1.25-1.25\" clip-rule=\"evenodd\"/>"
};